import './App.css';
import {Form,Button,Card,Image} from "react-bootstrap";
import React from 'react';
import logo from './assets/asdt_new_logo.png';
import fons from './assets/plantilla_2_powerpoint.jpg';

function Login(props) {
    const url = "/api";
    const [user, setUser] = React.useState({
        email: '',
        password: ''
    })

    async function logIn(e) {
        e.preventDefault();
        let options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                'Accept': '*/*',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
                "email": user.email,
                "password": user.password,
            })
        }
        let response = await fetch(url + '/login', options).catch(err => {
            console.log(err);
        });
        if (response.status !== 200) {
            console.log("Can't log in the user");
        } else {
            var dataReceived = await response.json();
            localStorage.setItem('token', dataReceived.token);
            localStorage.setItem('Login', user.email)
            props.setToken(dataReceived.token);
        }
    }


    return (
        <div style={{ backgroundColor: 'aliceblue', height: '100vh' , backgroundImage: `url(${fons})`,backgroundSize: 'cover',
    backgroundPosition: 'center',}}>
            <div>
                <div style={{ justifyContent: 'center', textAlign: 'center', paddingLeft: '400px', paddingRight: '400px',}}>
                    <Card style={{ paddingTop: '30px', paddingBottom: '40px', paddingLeft: '100px', paddingRight: '100px', top:'80px', borderRadius: '20px'}}>
                        <Form onSubmit={logIn}>
                            <Form.Group className="mb-5" controlId="formBasicEmail">
                                <Image src={logo} width='150px' style={{ textAlign: 'center', marginBottom: '40px'}} />
                                <br></br>
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" onChange={(e) => setUser({ email: e.target.value, password: user.password })} />
                            </Form.Group>

                            <Form.Group className="mb-5" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" placeholder="Password" onChange={(e) => setUser({ email: user.email, password: e.target.value })} />
                            </Form.Group>
                            <Button variant="primary" type="submit" style={{backgroundColor:'#076129', borderColor:'#076129'}}>
                                Submit
                            </Button>
                        </Form>
                    </Card>
                </div>
            </div>
        </div>
    );
  }

  export default Login;
